module.exports = __webpack_public_path__ + "img/detail-back.87903af1.svg";